// 라우트 전환 fallback — lazy 화면 청크가 도착하기 전 구간의 골격.
//
// 왜 필요한가: routes/index.tsx 의 라우트 49개가 lazy 이고, 그 사이 상위 <Suspense> 가
//   내용 없는 빈 div 를 렌더했다. 청크가 캐시에 없거나 저사양 기기면 "화면이 사라졌다가
//   다시 그려지는" 것으로 보인다(2026-08-28 효신님 지적). 스피너 대신 골격을 두는 이유는
//   전환이 끊기지 않고 이어져 보이는 쪽이 체감이 낫기 때문이다.
//
// ⚠ 실제 화면 헤더는 화면마다 달라서 흉내내지 않는다. 배경 + 제목 한 줄 + 카드 3장까지만
//   맞추고 나머지는 비운다 — 과하게 그리면 진짜 화면이 도착하는 순간 오히려 튄다.
// 색은 기존 토큰만 사용(--cs-bg · SkeletonCard 내부의 --cs-surface/--cs-line).
import { Skeleton, SkeletonCard } from './Skeleton';

export function RouteFallback() {
  return (
    <div
      aria-busy="true"
      aria-label="화면을 불러오는 중"
      style={{
        minHeight: '100vh',
        background: 'var(--cs-bg, #f5f1e8)',
        padding: '18px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      {/* 제목 자리 한 줄 — 대부분의 화면이 상단에 타이틀을 둔다 */}
      <Skeleton w="42%" h={20} style={{ marginBottom: 6 }} />
      <SkeletonCard lines={3} />
      <SkeletonCard lines={2} />
      <SkeletonCard lines={2} />
    </div>
  );
}
